import {RoadModel} from "../models/RoadModel"; 
import  {RoadStake} from "../models/RoadStake";
import  {RoadUnit} from "../models/RoadUnit";
import { Navigator } from '@/drawings3D/navigation'
import {EarthDrawer} from '../modelDrawing/EarthDrawer'

export class Road {
  constructor(id, roadType, roadName, sceneManager) {
    this.id = id;
    this.roadType = roadType;
    this.roadName = roadName;
    this.roadName = roadName;
    this.roadSections = new Object();
    this.roadSectionArr = [];
    this.sceneManager = sceneManager;
    this.singleRoadModelStakeRange = 200; 

    //主干道才跑车
    if (this.sceneManager.roadNav == undefined && this.roadType == 0){
      this.sceneManager.roadNav = new Navigator(this.sceneManager, this, 0, true, 0, 0);  
    }
  }


  getStakeRangeModelData(stakeRange){
    var roadStakes = this.roadModel.getStakesByRange(stakeRange);
    var stakeInterval = roadStakes[1].stakeval - roadStakes[0].stakeval;
    var startStakeIndex = (stakeRange.start - roadStakes[0].stakeval) / (roadStakes[1].stakeval - roadStakes[0].stakeval);
    var endStakeIndex = (stakeRange.end - stakeRange.start) / stakeInterval;
    var modelData = [];
    for (let i = startStakeIndex; i <= endStakeIndex; i++){
      modelData.push(roadStakes[i]);
    }
    return modelData;
  }

  getDrawStakeRanges(drawStakeRanges, modelData){
    var counter = 0;
    do{
      var endStakeCounter = counter + this.singleRoadModelStakeRange;
      //如果只剩下不足两段距离，则合并
      if (counter + 2 * this.singleRoadModelStakeRange > modelData.length - 1){
        endStakeCounter = modelData.length - 1;
      }
      var drawStakeRange = {start: counter, end: endStakeCounter};
      drawStakeRange.roadModel = this.roadModel;
      drawStakeRange.modelData = modelData;
      drawStakeRanges.push(drawStakeRange);

      if(endStakeCounter == modelData.length - 1) break;
      counter += this.singleRoadModelStakeRange;
    }while(counter < modelData.length);
   
    return;
  }


  process(roadModelData){
    // console.log(roadModelData.roadData[0].actualStakeVal, roadModelData.roadData[roadModelData.roadData.length - 1].actualStakeVal);
    var roadData = roadModelData.roadData;
    //将现有的道路分段建模
    if (this.roadModel == undefined){
      this.roadModel = new RoadModel(roadModelData, this.roadType, this.roadName, this.sceneManager);    
    }
    else{
      this.roadModel.buildRoadModel(roadModelData.roadData);
    }
     //1.判定传入的data哪些是现在已经有的，如果有则过滤掉不用渲染
    this.sceneManager.roadNav.getCameraPath(); //更新导航路线  
     //返回应该是连续的道路
     var startStake = roadData[0].stakeval;
     var endStake = roadData[roadData.length - 1].stakeval;

     //移除掉在视野范围之外的对象
     this.removeRenderedPart(startStake, endStake);

     var roadStakeRanges = [];
     for (var i = 0; i < this.roadSectionArr.length; i++){
      //roadSectionArr是从小到大依次排序且没有交集
      var section = this.roadSectionArr[i];
      if (section.startStake > endStake) break;  
      if (section.endStake < startStake) continue;
      //每次从服务器取的数据都是最大的，因此不考虑被已有数据完全包住的情况
      if (section.startStake < startStake) {
        startStake = section.endStake;
        continue;
      }
      if (section.startStake == startStake && section.endStake < endStake){
        startStake = section.endStake;
        continue;
      }
      if(section.startStake > startStake){
        var roadStakeRange = {start: startStake, end: section.startStake};
        roadStakeRanges.push(roadStakeRange);
        if (section.endStake < endStake){
           //section包含在取出的数据段中
           startStake = section.endStake;
           continue;
        }
        else{
          //section已经包含了后面所有的部分，后续的section肯定在该部分后面了，结束循环
          break;
        }
      }
     }
     
     if (startStake != endStake){
        var roadStakeRange = {start: startStake, end: endStake};
        roadStakeRanges.push(roadStakeRange);
     }

     var that = this;
     var drawStakeRanges = [];
     roadStakeRanges.map(item=>{
        var modelData = that.getStakeRangeModelData(item);
        that.getDrawStakeRanges(drawStakeRanges, modelData);
     });
     //TODO:对于多段道路，在roadmanager里面加载功能
    //1. 添加新的地形，2.移除掉之前的地形
    var terranRoadStakes = [];
    roadData.map(item=>{
      var stake = that.roadModel.getRoadStake(item.actualStakeVal);
      terranRoadStakes.push(stake);
    });
    this.sceneManager.EarthDrawer = new EarthDrawer(terranRoadStakes, roadModelData.demGrid.demData, this.sceneManager);
    this.sceneManager.EarthDrawer.render();    
    return drawStakeRanges;
  }

  markRoadOnMap(web3DView) {
    if (web3DView.map){
      web3DView.map.markRoad(this.roadModel, this.roadType);  
    }
    
  }
  
  addRenderPart(roadModel, range, renderedMesh){
      var startStake = range.modelData[range.start].stakeval;
      var endStake = range.modelData[range.end].stakeval;
      this.roadSections[startStake] = {
          startStake: startStake, endStake:endStake, mesh: renderedMesh, roadModel: roadModel
      };
      this.roadSectionArr.push(this.roadSections[startStake]);
      if (renderedMesh.roadSurface){
        this.sceneManager.scene.add(renderedMesh.roadSurface);  
      }
      if (renderedMesh.roadSigns){
        var roadSigns = renderedMesh.roadSigns;
        if(roadSigns.mediaDividers){
          roadSigns.mediaDividers.map(item=>{
             this.sceneManager.scene.add(item); 
          });
        }
        if(roadSigns.guardRails){
         roadSigns.guardRails.map(item=>{
             this.sceneManager.scene.add(item); 
          }); 
        }  
        if(roadSigns.laneDividers){
          roadSigns.laneDividers.map(item=>{
             this.sceneManager.scene.add(item); 
          });
        }
      }
 
  }

  removeMesh(object){
    var that = this; 
    if (object.uuid){
      this.sceneManager.scene.remove(object);
    }
    else if (object instanceof Array){
      object.map(item=>{
        that.removeMesh(item);
      });
    }
    else{
      for (var part in object){
            this.removeMesh(object[part]);  
      }
    }
  }
  removeRenderedPart(startStake, endStake){
    for(let i = 0; i < this.roadSectionArr.length - 1; i++){
        var section = this.roadSectionArr[i];
        if (section == undefined) continue;
        if (section.endStake < startStake || section.startStake > endStake){
          var mesh = section.mesh;
          // console.log("scene children before:"  + this.sceneManager.scene.children.length);
          this.removeMesh(mesh);
          // console.log("scene children after:"  + this.sceneManager.scene.children.length);
          delete this.roadSections[section.startStake];
          delete this.roadSectionArr[i];  
          // console.log("current range:",startStake, endStake, '---removed: ',section.startStake)
        }        
    }

    this.sceneManager.scene.dispose();
    this.sceneManager.renderer.dispose();

    this.roadSectionArrCpy = [];
    for(let i = 0; i < this.roadSectionArr.length; i++){
        if (this.roadSectionArr[i] != undefined){
          this.roadSectionArrCpy.push(this.roadSectionArr[i]);
        }
    }
    this.roadSectionArr = this.roadSectionArrCpy;
  }

  clearRenderedParts(){
    var _this = this;
      for(var stake in roadSections){
        var mesh = roadSections[startStake].renderedMesh;
        _this.sceneManager.scene.remove(mesh);
        delete roadSections[startStake];
      }
  }

  getRoadModel(){
    return this.roadModel;
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/Road.js